document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-sub-brands-marquee]').forEach(function (track) {
    const items = Array.prototype.slice.call(track.querySelectorAll('.sub-brands-logo'));
    if (!items.length) return;

    // Respect reduced motion: leave the static wrapped layout (set in CSS),
    // don't clone anything.
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    // Total width of one set of logos (including the 43px flex gap).
    let setWidth = 0;
    items.forEach(function (item) {
      setWidth += item.offsetWidth + 43;
    });
    if (setWidth <= 0) return;

    // Clone whole sets until the track is at least 2x the viewport, so the
    // -50% translate in @keyframes loops with no visible jump.
    const needed = Math.max(1, Math.ceil((window.innerWidth * 2) / setWidth));
    for (let i = 0; i < needed; i++) {
      items.forEach(function (item) {
        track.appendChild(item.cloneNode(true));
      });
    }

    function applySpeed() {
      const isMobile = window.innerWidth <= 768;
      const duration = isMobile
        ? (parseInt(track.dataset.mobileSpeed, 10) || 45)
        : (parseInt(track.dataset.desktopSpeed, 10) || 60);
      track.style.setProperty('--sub-brands-duration', duration + 's');
    }

    applySpeed();

    let wasMobile = window.innerWidth <= 768;
    window.addEventListener('resize', function () {
      const isMobile = window.innerWidth <= 768;
      if (isMobile !== wasMobile) {
        wasMobile = isMobile;
        applySpeed();
      }
    });
  });
});
